$('.datepicker').datepicker({
    format: "mm-yyyy",
    viewMode: "months",
    minViewMode: "months"
});
